import DialpadOutlinedIcon from '@mui/icons-material/DialpadOutlined';
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import RecommendOutlinedIcon from '@mui/icons-material/RecommendOutlined';
import React from 'react';

type Local = 'en' | 'fr';

interface ClientHubMobileFooterProps {
  scrollTo: any;
  activeSection: string;
  local: Local;
}

const menuItemStaticStyle: React.CSSProperties = {
  height: '80px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  fontSize: '80%',
  width: '20%',
};

const menuIconStyle: React.CSSProperties = {
  height: '48px',
  lineHeight: '60px',
  fontSize: '50px',
};

const menuItemColor = {
  selected: 'rgba(240, 248, 255, 1)',
  default: 'rgba(240, 248, 255, 0.5)',
};

const translations: Record<
  Local,
  {
    contact: string;
    payments: string;
    access: string;
    referrals: string;
    faqs: string;
  }
> = {
  en: {
    contact: 'Contact',
    payments: 'Payments',
    access: 'Access',
    referrals: 'Referrals',
    faqs: 'FAQs',
  },
  fr: {
    contact: 'Contact',
    payments: 'Paiements',
    access: 'Accès',
    referrals: 'Recommander',
    faqs: 'FAQ',
  },
};

const ClientHubMobileFooter: React.FC<ClientHubMobileFooterProps> = ({
  scrollTo,
  activeSection,
  local,
}) => {
  const t = translations[local];

  const menuItemDynamicStyle = (itemId: string): React.CSSProperties => ({
    backgroundColor:
      activeSection === itemId ? menuItemColor.selected : menuItemColor.default,
    boxShadow:
      activeSection === itemId
        ? 'lightblue 0px 0px 24px -16px inset'
        : undefined,
  });

  return (
    <div
      id="mobile-footer"
      className="fixed-bottom"
      style={{
        height: '80px',
        backgroundColor: 'white',
        opacity: 1,
        zIndex: 999,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-evenly',
          height: '80px',
        }}
      >
        <div
          onClick={() => scrollTo('contact')}
          style={{ ...menuItemStaticStyle, ...menuItemDynamicStyle('contact') }}
        >
          <div style={menuIconStyle}>
            <LocalPhoneOutlinedIcon />
          </div>
          <div>{t.contact}</div>
        </div>

        <div
          onClick={() => scrollTo('payment')}
          style={{ ...menuItemStaticStyle, ...menuItemDynamicStyle('payment') }}
        >
          <div style={menuIconStyle}>
            <PaymentOutlinedIcon />
          </div>
          <div>{t.payments}</div>
        </div>

        <div
          onClick={() => scrollTo('access')}
          style={{ ...menuItemStaticStyle, ...menuItemDynamicStyle('access') }}
        >
          <div style={menuIconStyle}>
            <DialpadOutlinedIcon />
          </div>
          <div>{t.access}</div>
        </div>

        <div
          onClick={() => scrollTo('referral')}
          style={{
            ...menuItemStaticStyle,
            ...menuItemDynamicStyle('referral'),
          }}
        >
          <div style={menuIconStyle}>
            <RecommendOutlinedIcon />
          </div>
          <div>{t.referrals}</div>
        </div>

        <div
          onClick={() => scrollTo('faq')}
          style={{ ...menuItemStaticStyle, ...menuItemDynamicStyle('faq') }}
        >
          <div style={menuIconStyle}>
            <HelpCenterOutlinedIcon />
          </div>
          <div>{t.faqs}</div>
        </div>
      </div>
    </div>
  );
};

export default ClientHubMobileFooter;
